import { Col, Row } from "react-bootstrap";
import { TbConfetti } from "react-icons/tb";

const DoneMask = ({message}) => {

    return (
        <div className="text-center">
            <Row className="mt-3">
                <Col xl="12">
                    <div className="animate__animated animate__backInRight">
                        <TbConfetti size={80} className="text-energo animate__animated animate__tada animate__delay-2s" />
                    </div>
                </Col>
            </Row>
            <Row className="mt-5">
                <Col>
                    <h3 className="text-energo">Fertig!</h3>
                    <p className="text-muted mt-3">{message}</p>
                </Col>
            </Row>
        </div>
    )
}
export default DoneMask;